module.exports = __webpack_public_path__ + "img/s.29226f65.png";